var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FieldEditorService } from '@/presentation/components/field-editor/field-editor-service.interface';
let LayerFieldSelectServiceImp = class LayerFieldSelectServiceImp {
    constructor(_fieldEditorService) {
        this._fieldEditorService = _fieldEditorService;
    }
    select(fn) {
        const value = fn(this._fieldEditorService.value || []);
        this._fieldEditorService.setNewValue(value, true);
    }
};
LayerFieldSelectServiceImp = __decorate([
    injectable(),
    __param(0, inject(FieldEditorService)),
    __metadata("design:paramtypes", [typeof (_a = typeof FieldEditorService !== "undefined" && FieldEditorService) === "function" ? _a : Object])
], LayerFieldSelectServiceImp);
export { LayerFieldSelectServiceImp };
